module.exports = __webpack_public_path__ + "img/step2.ffdd79fd.svg";